import { render } from "./payment.vue?vue&type=template&id=62752448&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=62752448&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62752448"],['__file',"src/views/payment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62752448"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62752448', __exports__)) {
    console.log('reload')
    api.reload('62752448', __exports__)
  }
  
  module.hot.accept("./payment.vue?vue&type=template&id=62752448&scoped=true", () => {
    console.log('re-render')
    api.rerender('62752448', render)
  })

}


export default __exports__